import React, { DispatchWithoutAction, FC, MouseEvent } from 'react';
import classNames from 'classnames';

import { fc } from 'i18n';
import { ISelectOption } from 'types/select';
import { FiltersTypes, IFilter } from 'types/filters';

import styles from '../styles.module.css';

interface ISelectFilterProps {
  selectedFilter: IFilter | null;
  offset?: number;
  options?: ISelectOption<string | number>[];
  onMouseEnter: DispatchWithoutAction;
  setFilterValue: (option: string | number) => (event: MouseEvent<HTMLDivElement>) => void;
}

export const SelectFilter: FC<ISelectFilterProps> = (props) => {
  const { selectedFilter, offset, options, setFilterValue, onMouseEnter } = props;

  const isSelected = selectedFilter?.type && selectedFilter?.type === FiltersTypes.Select;

  const listClassname = classNames(styles.list, { [styles.show]: isSelected, [styles.hide]: !isSelected });

  const listStyles = { left: `${(offset || 0) + 10}px` };

  return (
    <div className={listClassname} style={listStyles} onMouseEnter={onMouseEnter}>
      {options?.map((option, index) => (
        <div key={index} className={styles.option} onClick={setFilterValue(option.value)}>
          {fc(option.label)}
        </div>
      ))}
    </div>
  );
};
